import { Injectable } from '@angular/core';


@Injectable()
export class DesktopUserDataService {

    USER_DATA_TYPES = {
        NOTE: "note",
        DRAWING: "drawing",
        PREFERENCE: "preference"
    }

    constructor(
    ){
    }

    /**
     * Set full ebooks note for a user to the DB
     * @param params : {uid, ebookCode, data}
     * @param uid : userId
     * @param ebookCode : ebookCode
     * @param data : notes data as fetched from server
     * @returns 
     */
    async setBulkRecords(params){
        if(params.uid && params.ebookCode && params.data){
            return await DLS_IPCCallers.SET_BULK_USER_DATA_RECORDS(params);
        }else{
            throw("INVALID_PARAMS");
        }
    }

    /**
     * method to update a note
     * @param params {uid, ebookCode, data}
     * @returns 
     */
    async updateRecord(params){
        if(params.uid && params.ebookCode && params.data){
            return await DLS_IPCCallers.UPDATE_USER_DATA_RECORD(params);
        }else{
            throw("INVALID_PARAMS");
        }
    }

    /**
     * method to get note(s) of an ebook for a user
     * @param params : {uid, ebookCode, documentId?}
     */
    async getRecords(params){
        if(params.uid && params.ebookCode){
            return await DLS_IPCCallers.GET_USER_DATA_RECORDS(params);
        }else{
            throw("INVALID_PARAMS");
        }
    }


    /**
     * method to delete note(s) of an ebook for a user
     * @param params : {uid, ebookCode, documentId?}
     * @param uid : userId
     * @param ebookCode : ebookCode
     * @param documentId : if given, only one note will be deleted.
     * If no documentId is passed then all the notes will be deleted
     */
     async deleteRecords(params){
        if(params.uid && params.ebookCode){
            return await DLS_IPCCallers.DELETE_USER_DATA_RECORDS(params);
        }else{
            throw("INVALID_PARAMS");
        }
    }
    
}